export default {"src":"/_next/static/media/fmcg.35927d4d.svg","height":47,"width":49};